var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTierTag = function SvgTierTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8E56D5",
    d: "M4.124 19.16.778 3.404A2 2 0 0 1 2.735.988l87.517.02a2 2 0 0 1 1.955 2.419l-3.351 15.675a2 2 0 0 1-1.954 1.581l-80.82.062a2 2 0 0 1-1.958-1.584"
  })));
};
export default SvgTierTag;